import {
    PARAMETERS,
    THEME,
    MAINCOLOR
} from './actionTypes';

export const fetchParameters = params => {
    return {
        type: PARAMETERS,
        payload: params
    }
}

export const setTheme = params => {
    return {
        type: THEME,
        payload: params
    }
}
export const setMainColor = params => {
    return {
        type: MAINCOLOR,
        payload: params
    }
}